/* eslint-disable camelcase */
import React, { useState, useContext } from 'react';
import { Checkbox } from '@nextiva/next-ui-components';
import clsx from 'clsx';
import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { LicensesContext, actionTypes } from '../../../licensesContext';

export const EditAssignmentTableHeader = () => {
  const [checked, setChecked] = useState(false);
  const [ascendingSort, setAscendingSort] = useState(true);

  const {
    dispatch,
    licensesState: {
      selectedUserList,
      initialSelectedUserList,
      filteredUserList,
      editLicenseAssignment: {
        licenseDefinition: { licenseType } = {},
        license_definition: { license_type } = {},
        license_count,
        licenseCount,
      },
    },
  } = useContext(LicensesContext);
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  const userList = filteredUserList.filter((user) => user.active) || [];
  const indeterminate = !(
    userList.length === selectedUserList.length || selectedUserList.length === 0
  );
  const tableHeaderText =
    !checked && !indeterminate
      ? 'Name'
      : `${selectedUserList.length} users selected`;
  const usersSelected = selectedUserList.length > 0;
  const tableHeaderTextColor =
    selectedUserList.length > license_count ||
    selectedUserList.length > licenseCount
      ? 'table-header-text-error-color'
      : 'table-header-text-color';
  const sortOrder = ascendingSort ? 'asc_icon' : 'desc_icon';

  const onCheckBoxClick = () => {
    setChecked(!checked);
    dispatch({
      type: actionTypes.SELECT_ALL_LICENSED_USERS,
      data: {
        checked: !checked,
        initialSelectedUserList,
        userList,
        license_type: license_type || licenseType,
        authV3Enabled,
      },
    });
  };

  const onSortIconClick = () => {
    setAscendingSort(!ascendingSort);
    dispatch({
      type: actionTypes.SORT_LICENSES_USER_LIST,
      ascendingSort: !ascendingSort,
    });
  };

  return (
    <div
      className={clsx(
        'm-edit-aassignment-table-header',
        usersSelected && 'm-edit-aassignment-table-header-background',
      )}
    >
      <div
        className="checkbox"
        role="presentation"
        onClick={onCheckBoxClick}
        data-testid="PlatformAdminUI-Licensing-EditAssignment-TableHeader"
      >
        <Checkbox
          checked={checked}
          indeterminate={indeterminate}
          data-testid="PlatformAdminUI-Licensing-EditAssignment-TableHeaderCheckBox"
        />
      </div>
      <span
        className={clsx('table-header-text', 'Heading6', tableHeaderTextColor)}
        data-testid="PlatformAdminUI-Licensing-EditAssignment-TableHeaderText"
      >
        {tableHeaderText}
      </span>
      {!checked && !indeterminate && (
        <span
          className={clsx('sort_icon', sortOrder)}
          onClick={onSortIconClick}
          role="presentation"
          data-testid="PlatformAdminUI-EditAssignment-Sort"
        />
      )}
    </div>
  );
};
